import { useEffect, useState } from 'react';
import { Input, type InputProps } from '@fluentui/react-components';
import { SearchRegular } from '@fluentui/react-icons';
import { useDebouncedCallback } from 'use-debounce';

type TProps = Omit<InputProps, 'value' | 'defaultValue' | 'onChange'> & {
  value: string;
  onChange: (value: string) => void;
};

const SearchInput = ({ value, onChange, ...props }: TProps) => {
  const [draft, setDraft] = useState(value);
  // A draft equal to the incoming value is a no-op; emitting it would still reset consumers' page.
  const update = useDebouncedCallback((next: string) => {
    if (next !== value) onChange(next);
  }, 300);
  useEffect(() => {
    update.cancel();
    setDraft(value);
  }, [value, update]);
  useEffect(() => () => update.cancel(), [update]);
  return (
    <Input
      contentBefore={<SearchRegular />}
      {...props}
      value={draft}
      onChange={(_, data) => {
        setDraft(data.value);
        update(data.value);
      }}
    />
  );
};
export default SearchInput;
